const isFetchError = (e: unknown): e is Error & { response: Response } => (e as { response: Response })?.response?.json !== undefined;
export default isFetchError;
